(function () {
  const yearEl = document.getElementById("mewFooterYear");
  if (yearEl) yearEl.textContent = String(new Date().getFullYear());
})();
